import React, { Component, PropTypes as T } from 'react';
import './avatar.less';
 
export default class Avatar extends Component {

	static propTypes = {
    	avatar: T.string.isRequired
  	};

	static defaultProps = {
    	badge: null,
    	size: 30,
        onMouseOver: () => {},
        onMouseOut: () => {}
  	};

	render() {
		var { avatar, badge, size, onMouseOver, onMouseOut } = this.props;
		
		var avatarStyle = {
			width: size,
			minHeight: size,
			minWidth: size,
		};

		if(badge) {
			var badgeClasses = "b3-icon b3-icon-streamline-24px avatar-badge sl-icon-" + badge;    
			return (
				<div onMouseOver={onMouseOver}
                     onMouseOut={onMouseOut}
                     className="b3-avatar"
                     style={{width: size}}>
					    <img style={avatarStyle} className="avatar-image" src={avatar} />
					    <span className={badgeClasses}></span>
				</div>
			);
		}

		return (
			<div onMouseOver={onMouseOver}
                 onMouseOut={onMouseOut}
                 className="b3-avatar">
				<img style={avatarStyle} className="avatar-image" src={avatar} />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./app/b3/avatar/Avatar.js